/* src/app/shared/components/form-controls/ag-radio-group/ag-radio-group.component.scss */
input[type=radio] {
  display: none;
}
input[type=radio] + label {
  font-size: 12px;
  color: #f2eee7;
  margin: 0;
  border-radius: 8px;
  border: solid 1px #333;
  padding: 6px 16px;
  color: #333;
  box-sizing: border-box;
  display: inline-block;
  cursor: pointer;
}
input[type=radio] + label img {
  width: 34px;
  padding: 4px;
}
input[type=radio] + label.ag-radio-group-option-small {
  margin: 0;
  padding: 0;
}
input[type=radio] + label.ag-radio-group-option-small img {
  width: 16px;
  padding: 2px;
}
input[type=radio] + label.ag-radio-group-option-large {
  font-size: 20px;
  color: #61566e;
  margin: 0 0 8px 0;
  width: 89px;
  height: 70px;
  padding: 8px 8px;
  border: solid 1px #61566e;
  font-weight: 900;
  text-align: center center;
}
input[type=radio] + label.ag-radio-group-option-large img {
  width: 64px;
  padding: 8px;
}
input[type=radio] + label .subtext {
  font-size: 10px;
}
input[type=radio]:checked + label {
  box-shadow: 0 1px 3px 0 rgba(140, 140, 140, 0.75);
  background-color: #61566e;
  color: #f2eee7;
}
input[type=radio]:checked + label img {
  filter: brightness(0) invert(1);
}
.disabled {
  opacity: 0.5;
  background-color: white;
}
/*# sourceMappingURL=ag-radio-group.component.css.map */
